module.exports = __webpack_public_path__ + "img/wine_empty.3f17ac88.png";